import index from '@/components/conf/index/index.vue'
import empty from '@/components/common/empty/empty.vue'
export default {
  path: '/live',
  component: index,
  redirect: '/live/classification',
  name: '步步高直播',
  iconCls: '&#xe794;',
  children: [{
    path: 'classification',
    name: '直播间分类',
    iconCls: '&#xe803;',
    component: resolve => require(['@/components/conf/live/classification/index.vue'], resolve)
  }, {
    path: 'configure',
    component: empty,
    name: '直播间配置',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/live/configure/index',
    children: [{
      path: 'index',
      component: resolve => require(['@/components/conf/live/configure/index.vue'], resolve),
      name: '直播间配置列表'
    }, {
      path: '@edit',
      component: resolve => require(['@/components/conf/live/configure/add.vue'], resolve),
      name: '编辑',
      iconCls: '&#xe803;',
      children: []
    }]
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/live.js